import { AutogenModelArControlIntercompany, AutogenRowArControlIntercompany } from "./autogen/AutogenModelArControlIntercompany";

export class ModelArControlIntercompany extends AutogenModelArControlIntercompany<RowArControlIntercompany> {
	constructor() {
		super(RowArControlIntercompany);
	}
}

export class RowArControlIntercompany extends AutogenRowArControlIntercompany {
}